import React from 'react';
import _ from "lodash";
import moment from "moment/moment.js";
import { DeclarationAssurance, DeclarationFormation } from "@amo/core/components/questions/index.js";

const Attestation125 = (props) => {
    const { data, vehicule } = props;
    const permis = _.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]', []);
    const datePermisB = _.find(permis, ['TypePermis', 'B']) ? moment(_.find(permis, ['TypePermis', 'B']).DatePermis, 'DD/MM/YYYY') : null;
    const familleProduit = vehicule?.type?.id;
    const cylindree = Number(vehicule?.cylindree || 0);

    const hasOnlyPermisB = (permis) => {
        return !_.find(permis, p => ['A1', 'A', 'A2'].includes(p?.TypePermis)) && _.find(permis, ['TypePermis', 'B']);
    };

    return (
        <div>
            {(
                (_.includes(['moto', 'scooter', 'verte'], familleProduit) && cylindree > 50 && cylindree <= 125 && hasOnlyPermisB(permis)) ||
                (vehicule?.genre === 'TRI' && !_.find(permis, p => p?.TypePermis === 'A'))
            ) && (
                <>
                    {(datePermisB >= moment('2011-01-01') ||
                        (datePermisB >= moment('1980-03-01') && datePermisB < moment('2011-01-01'))) && (
                        <DeclarationFormation {...props} datePermisB={datePermisB} />
                    )}
                    {(datePermisB >= moment('1980-03-01') &&
                        datePermisB < moment('2011-01-01') &&
                        _.get(data, 'DemandeTarif[ListePersonnes][0][Formation]') === '0') && (
                        <DeclarationAssurance {...props} datePermisB={datePermisB} />
                    )}
                </>
            )}
        </div>
    );
};

export default Attestation125;